module.exports = __webpack_public_path__ + "static/media/blingV3_13.76e15b43.png";